import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=c2b90b9c&scoped=true"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"
import style0 from "./Results.scss?vue&type=style&index=0&id=c2b90b9c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b90b9c",
  null
  
)

export default component.exports